
const API_ROOT = 'https://app-node.talkdev.com:3021';
// const API_ROOT = 'http://localhost:3021';

// const webPath = 'https://enterprisetalk.com'  // for testing images

const webPath = 'https://talkdev.com'
// const webPath = 'https://talkdev.ondotmail.com'


export { API_ROOT, webPath };
